import React from 'react';

/**
 * Modal que muestra el código de barras e información de un equipo seleccionado
 *
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.showBarcodeModal - Controla la visibilidad del modal
 * @param {Function} props.setShowBarcodeModal - Función para cambiar la visibilidad del modal
 * @param {Object} props.selectedEquipoModal - Datos del equipo seleccionado
 * @param {string} props.barcodeImageUrl - URL de la imagen del código de barras
 * @param {boolean} props.loadingBarcode - Indica si se está cargando la imagen
 * @param {Array} props.grupos - Lista de grupos disponibles para mostrar información
 * @param {Array} props.tipos - Lista de tipos disponibles para mostrar información
 * @param {Array} props.medidas - Lista de medidas disponibles para mostrar información
 * @param {Function} props.addCatalogCodeToScanner - Función para añadir el código al escáner
 * @returns {JSX.Element|null} El modal de códigos de barras o null si está cerrado
 */
const BarcodeModal = ({
  showBarcodeModal,
  setShowBarcodeModal,
  selectedEquipoModal,
  barcodeImageUrl,
  loadingBarcode,
  grupos,
  tipos,
  medidas,
  marcas,
  addCatalogCodeToScanner
}) => {
  if (!showBarcodeModal || !selectedEquipoModal) return null;
  
  return (
    <div className="barcode-modal-overlay" onClick={() => setShowBarcodeModal(false)}>
      <div className="barcode-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="barcode-modal-header">
          <h3>Código de Barras</h3>
          <button className="barcode-modal-close" onClick={() => setShowBarcodeModal(false)}>
            ×
          </button>
        </div>
        
        <div className="barcode-modal-body">
          <div className="barcode-modal-info">
            <p><strong>Marca:</strong> {marcas.find(m => m.idmarca === selectedEquipoModal.idmarca)?.marca || "-"}</p>
            <p><strong>Descripción:</strong> {selectedEquipoModal.descripcion || "-"}</p>
            <p><strong>Grupo:</strong> {grupos.find(g => g.idgrupoinstalacion === selectedEquipoModal.idgrupoinstalacion)?.grupoinstalacion || "-"}</p>
            <p><strong>Tipo:</strong> {tipos.find(t => t.idtipoinstalacion === selectedEquipoModal.idtipoinstalacion)?.tipoinstalacion || "-"}</p>
            <p><strong>Medida:</strong> {medidas.find(m => m.idmedidainstalacion === selectedEquipoModal.idmedidainstalacion)?.medidainstalacion || "-"}</p>
            {selectedEquipoModal.usa_codigo_fabrica && selectedEquipoModal.codigo_fabrica && (
              <p><strong>Código de fábrica:</strong> {selectedEquipoModal.codigo_fabrica}</p>
            )}
          </div>
          
          <div className="barcode-modal-image-container">
            {loadingBarcode ? (
              <div className="barcode-modal-loading">
                <div className="scanner-spinner"></div>
                <p>Cargando código...</p>
              </div>
            ) : selectedEquipoModal.codigo && barcodeImageUrl ? (
              <img 
                src={barcodeImageUrl} 
                alt="Código de barras" 
                className="barcode-modal-image" 
                onError={(e) => {
                  console.error("Error al cargar la imagen");
                  e.target.src = "https://via.placeholder.com/200x100?text=Error+al+cargar";
                }}
              />
            ) : (
              <div className="barcode-modal-no-code">
                {selectedEquipoModal.codigo ? 
                  "Error al cargar el código de barras" : 
                  "Este equipo no tiene código de barras asignado"}
              </div>
            )}
          </div>
          
          <div className="barcode-modal-actions">
            <button 
              className="barcode-modal-button scan-button"
              onClick={() => addCatalogCodeToScanner(selectedEquipoModal)}
            >
              <i className="fa-solid fa-plus"></i> Agregar a escáner
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(BarcodeModal);
